/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SecurityRouteRouteImport } from './routes/security/route'
import { Route as LegalRouteRouteImport } from './routes/legal/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SecurityIndexRouteImport } from './routes/security/index'
import { Route as SecurityResponsibleDisclosureRouteImport } from './routes/security/responsible-disclosure'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalSubprocessorsRouteImport } from './routes/legal/subprocessors'
import { Route as LegalSlaRouteImport } from './routes/legal/sla'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalDpaRouteImport } from './routes/legal/dpa'
import { Route as LegalCookiesRouteImport } from './routes/legal/cookies'
import { Route as LegalAcceptableUseRouteImport } from './routes/legal/acceptable-use'

const SecurityRouteRoute = SecurityRouteRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRouteRoute = LegalRouteRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityIndexRoute = SecurityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecurityRouteRoute,
} as any)
const SecurityResponsibleDisclosureRoute =
  SecurityResponsibleDisclosureRouteImport.update({
    id: '/responsible-disclosure',
    path: '/responsible-disclosure',
    getParentRoute: () => SecurityRouteRoute,
  } as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalSubprocessorsRoute = LegalSubprocessorsRouteImport.update({
  id: '/subprocessors',
  path: '/subprocessors',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalSlaRoute = LegalSlaRouteImport.update({
  id: '/sla',
  path: '/sla',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalDpaRoute = LegalDpaRouteImport.update({
  id: '/dpa',
  path: '/dpa',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalCookiesRoute = LegalCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalAcceptableUseRoute = LegalAcceptableUseRouteImport.update({
  id: '/acceptable-use',
  path: '/acceptable-use',
  getParentRoute: () => LegalRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/legal': typeof LegalRouteRouteWithChildren
  '/security': typeof SecurityRouteRouteWithChildren
  '/legal/acceptable-use': typeof LegalAcceptableUseRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/sla': typeof LegalSlaRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/legal/terms': typeof LegalTermsRoute
  '/security/responsible-disclosure': typeof SecurityResponsibleDisclosureRoute
  '/security/': typeof SecurityIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/legal': typeof LegalRouteRouteWithChildren
  '/legal/acceptable-use': typeof LegalAcceptableUseRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/sla': typeof LegalSlaRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/legal/terms': typeof LegalTermsRoute
  '/security/responsible-disclosure': typeof SecurityResponsibleDisclosureRoute
  '/security': typeof SecurityIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/legal': typeof LegalRouteRouteWithChildren
  '/security': typeof SecurityRouteRouteWithChildren
  '/legal/acceptable-use': typeof LegalAcceptableUseRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/sla': typeof LegalSlaRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/legal/terms': typeof LegalTermsRoute
  '/security/responsible-disclosure': typeof SecurityResponsibleDisclosureRoute
  '/security/': typeof SecurityIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/legal'
    | '/security'
    | '/legal/acceptable-use'
    | '/legal/cookies'
    | '/legal/dpa'
    | '/legal/privacy'
    | '/legal/sla'
    | '/legal/subprocessors'
    | '/legal/terms'
    | '/security/responsible-disclosure'
    | '/security/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/legal'
    | '/legal/acceptable-use'
    | '/legal/cookies'
    | '/legal/dpa'
    | '/legal/privacy'
    | '/legal/sla'
    | '/legal/subprocessors'
    | '/legal/terms'
    | '/security/responsible-disclosure'
    | '/security'
  id:
    | '__root__'
    | '/'
    | '/legal'
    | '/security'
    | '/legal/acceptable-use'
    | '/legal/cookies'
    | '/legal/dpa'
    | '/legal/privacy'
    | '/legal/sla'
    | '/legal/subprocessors'
    | '/legal/terms'
    | '/security/responsible-disclosure'
    | '/security/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LegalRouteRoute: typeof LegalRouteRouteWithChildren
  SecurityRouteRoute: typeof SecurityRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security/': {
      id: '/security/'
      path: '/'
      fullPath: '/security/'
      preLoaderRoute: typeof SecurityIndexRouteImport
      parentRoute: typeof SecurityRouteRoute
    }
    '/security/responsible-disclosure': {
      id: '/security/responsible-disclosure'
      path: '/responsible-disclosure'
      fullPath: '/security/responsible-disclosure'
      preLoaderRoute: typeof SecurityResponsibleDisclosureRouteImport
      parentRoute: typeof SecurityRouteRoute
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/subprocessors': {
      id: '/legal/subprocessors'
      path: '/subprocessors'
      fullPath: '/legal/subprocessors'
      preLoaderRoute: typeof LegalSubprocessorsRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/sla': {
      id: '/legal/sla'
      path: '/sla'
      fullPath: '/legal/sla'
      preLoaderRoute: typeof LegalSlaRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/dpa': {
      id: '/legal/dpa'
      path: '/dpa'
      fullPath: '/legal/dpa'
      preLoaderRoute: typeof LegalDpaRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/cookies': {
      id: '/legal/cookies'
      path: '/cookies'
      fullPath: '/legal/cookies'
      preLoaderRoute: typeof LegalCookiesRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/acceptable-use': {
      id: '/legal/acceptable-use'
      path: '/acceptable-use'
      fullPath: '/legal/acceptable-use'
      preLoaderRoute: typeof LegalAcceptableUseRouteImport
      parentRoute: typeof LegalRouteRoute
    }
  }
}

interface LegalRouteRouteChildren {
  LegalAcceptableUseRoute: typeof LegalAcceptableUseRoute
  LegalCookiesRoute: typeof LegalCookiesRoute
  LegalDpaRoute: typeof LegalDpaRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalSlaRoute: typeof LegalSlaRoute
  LegalSubprocessorsRoute: typeof LegalSubprocessorsRoute
  LegalTermsRoute: typeof LegalTermsRoute
}

const LegalRouteRouteChildren: LegalRouteRouteChildren = {
  LegalAcceptableUseRoute: LegalAcceptableUseRoute,
  LegalCookiesRoute: LegalCookiesRoute,
  LegalDpaRoute: LegalDpaRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalSlaRoute: LegalSlaRoute,
  LegalSubprocessorsRoute: LegalSubprocessorsRoute,
  LegalTermsRoute: LegalTermsRoute,
}

const LegalRouteRouteWithChildren = LegalRouteRoute._addFileChildren(
  LegalRouteRouteChildren,
)

interface SecurityRouteRouteChildren {
  SecurityResponsibleDisclosureRoute: typeof SecurityResponsibleDisclosureRoute
  SecurityIndexRoute: typeof SecurityIndexRoute
}

const SecurityRouteRouteChildren: SecurityRouteRouteChildren = {
  SecurityResponsibleDisclosureRoute: SecurityResponsibleDisclosureRoute,
  SecurityIndexRoute: SecurityIndexRoute,
}

const SecurityRouteRouteWithChildren = SecurityRouteRoute._addFileChildren(
  SecurityRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LegalRouteRoute: LegalRouteRouteWithChildren,
  SecurityRouteRoute: SecurityRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
